import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=5df2402c&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df2402c",
  null
  
)

export default component.exports